<div class="container-fluid">
  <div class="row justify-content-start">
    <div class="col-12">
      <!-- Title -->
      <h1 class="fw-semibold fs-3 fs-lg-1 lh-sm ls-1 text-dark mb-3">
        {{ 'translate_terms_and_conditions' | translate }}
      </h1>
      
      <!-- Introduction -->
      <p class="fw-normal fs-5 fs-lg-5 lh-sm ls-1 text-secondary mb-5">
        {{ 'translate_terms_intro' | translate }}
      </p>
      
      <!-- Section 1: Acceptance of Terms -->
      <div class="mb-5">
        <h2 class="fw-semibold fs-5 fs-lg-5 lh-sm ls-1 text-dark mb-3 d-flex align-items-start">
          <span class="me-2">{{ '1' | translate }}.</span>
          {{ 'translate_terms_section_1_title' | translate }}
        </h2>
        <ul class="list-unstyled ps-0 m-0 mx-4">
          <li class="fw-normal fs-5 fs-lg-5 lh-sm ls-1 text-secondary mb-3 ps-4 position-relative">
            <span class="position-absolute start-0 w-1 h-1 bg-dark rounded-circle" style="top: 8px;"></span>
            {{ 'translate_terms_section_1_item_1' | translate }}
          </li>
          <li class="fw-normal fs-5 fs-lg-5 lh-sm ls-1 text-secondary mb-3 ps-4 position-relative">
            <span class="position-absolute start-0 w-1 h-1 bg-dark rounded-circle" style="top: 8px;"></span>
            {{ 'translate_terms_section_1_item_2' | translate }}
          </li>
        </ul>
      </div>
      
      <!-- Section 2: Services -->
      <div class="mb-5">
        <h2 class="fw-semibold fs-5 fs-lg-5 lh-sm ls-1 text-dark mb-3 d-flex align-items-start">
          <span class="me-2">{{ '2' | translate }}.</span>
          {{ 'translate_terms_section_2_title' | translate }}
        </h2>
        <ul class="list-unstyled ps-0 m-0 mx-4">
          <li class="fw-normal fs-5 fs-lg-5 lh-sm ls-1 text-secondary mb-3 ps-4 position-relative">
            <span class="position-absolute start-0 w-1 h-1 bg-dark rounded-circle" style="top: 8px;"></span>
            {{ 'translate_terms_section_2_item_1' | translate }}
          </li>
          <li class="fw-normal fs-5 fs-lg-5 lh-sm ls-1 text-secondary mb-3 ps-4 position-relative">
            <span class="position-absolute start-0 w-1 h-1 bg-dark rounded-circle" style="top: 8px;"></span>
            {{ 'translate_terms_section_2_item_2' | translate }}
          </li>
        </ul>
      </div>
      
      <!-- Section 3: User Conduct -->
      <div class="mb-5">
        <h2 class="fw-semibold fs-5 fs-lg-5 lh-sm ls-1 text-dark mb-3 d-flex align-items-start">
          <span class="me-2">{{ '3' | translate }}.</span>
          {{ 'translate_terms_section_3_title' | translate }}
        </h2>
        <ul class="list-unstyled ps-0 m-0 mx-4">
          <li class="fw-normal fs-5 fs-lg-5 lh-sm ls-1 text-secondary mb-3 ps-4 position-relative">
            <span class="position-absolute start-0 w-1 h-1 bg-dark rounded-circle" style="top: 8px;"></span>
            {{ 'translate_terms_section_3_item_1' | translate }}
          </li>
          <li class="fw-normal fs-5 fs-lg-5 lh-sm ls-1 text-secondary mb-3 ps-4 position-relative">
            <span class="position-absolute start-0 w-1 h-1 bg-dark rounded-circle" style="top: 8px;"></span>
            {{ 'translate_terms_section_3_item_2' | translate }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>